PegasusTemplate.ActivePortionControlController = Em.Controller.extend({
  needs: ['viewOptions'],
  zoomValue: function(){
    return this.get('controllers.viewOptions.zoomValue');
  }.property('controllers.viewOptions.zoomValue')
});
